jQuery(document).on('ready', function () {
    
    // Check if component is added to the page
    if( jQuery('section.video').length ) {

        // Play / pause video
        jQuery('section.video .video-container .video-action').on('click', function() {
            var videoContainer = jQuery(this).parent();
            // Remove video thumbnail
            if( videoContainer.children('video.video-thumbnail').length ) {
                videoContainer.children('video.video-thumbnail').remove();
            }
            // Play / pause video
            var videoFull = videoContainer.children('video.video-full')[0];
            if( videoContainer.hasClass('playing') ) {
                videoFull.pause();
                videoContainer.removeClass('playing');
            } else {
                videoFull.play();
                videoContainer.addClass('playing');
            }
        });
        // Check if video has ended
        jQuery('section.video').on('mouseenter mouseleave', '.video-container.playing', function() {
            var videoContainer = jQuery(this);
            var videoFull = videoContainer.children('video.video-full')[0];
            if( videoFull.ended ) {
                videoContainer.removeClass('playing');
            } else {
                videoContainer.addClass('playing');
            }
        });
    }

});